module.exports = __webpack_public_path__ + "assets/img/qrcode.a508bb8a.png";